export default __webpack_public_path__ + "static/media/cloud-large.19e8df16.jpg";